import { h as __h } from "preact";
import { signal } from "@preact/signals";
import { identity } from "~/lib/identity.js";
import html from "~/util/html.js";
import { persist } from "~/util/persist.js";
import { array, parse, string } from "~/util/validate.js";
import Button from "~/component/Button.js";
import Icon from "~/component/Icon.js";
import { createEnterprise } from "~/admin/res/enterprise/actions/createEnterprise.js";
import util from "~/style/util.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./BusinessCard.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./BusinessCard.module.css", import.meta.url);
const css = adopt(sheet);

// the IDs of the users who have dismissed the card, since several people can share a browser
const dismissedBy = signal(/** @type {string[]} */[]);
persist(dismissedBy, "business_card_dismissed_by", {
  parse: s => parse(array(string), s)
});

/** Pitches enterprises to people who aren't in one, shown in the sidebar until they dismiss it. */
export default function BusinessCard() {
  const userId = identity.me?.id;
  if (!userId || identity.enterprise || dismissedBy.value.includes(userId)) return null;
  return __h("div", {
    "class": util.card + " " + css.card
  }, __h("div", {
    "class": css.copy
  }, __h("h2", {
    "class": css.title
  }, "Using Phaze for your business?"), __h("p", {
    "class": css.blurb
  }, "Manage your team's computers and access in one place, with SSO, audit logs, an API, and more.")), __h(Button, {
    level: "primary",
    onClick: createEnterprise
  }, "Set up your business"), __h("div", {
    "class": css.dismiss
  }, __h(Button, {
    level: "tertiary",
    size: "small",
    onClick: () => {
      dismissedBy.value = [...dismissedBy.value, userId];
    }
  }, __h(Icon, {
    name: "ex",
    size: 12,
    label: "Dismiss"
  }))));
}